import {
  CartTargetingFe,
  CheckoutBlockDto,
  ExperienceTestTypeDto,
  OfferDto,
  OfferProductDto,
  OnsiteEditDto,
  OnsiteInjectionDto,
  PostPurchaseUpsellCheckoutBlockDto,
  UpsellProductRulesDto,
  UserInterfaceDto,
} from "@intelligems/ig-types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IDraftExperienceState } from "./types";

const initialState: IDraftExperienceState = {
  draftExperience: undefined,
  isSuccess: false,
};

const draftExperienceSlice = createSlice({
  name: "draftExperience",
  initialState,
  reducers: {
    setDraftExperience: (
      draft,
      action: PayloadAction<{
        offer?: OfferDto;
        offerProducts?: OfferProductDto[];
        userInterfaces?: UserInterfaceDto[];
        onsiteInjections?: OnsiteInjectionDto[];
        onsiteEdits?: OnsiteEditDto[];
        checkoutBlocks?: CheckoutBlockDto[];
        postPurchaseBlocks?: PostPurchaseUpsellCheckoutBlockDto[];
        cartTargeting?: CartTargetingFe[];
        upsellProductRules?: UpsellProductRulesDto[];
        testTypes: ExperienceTestTypeDto;
      }>
    ) => {
      const {
        offer,
        offerProducts,
        userInterfaces,
        onsiteInjections,
        onsiteEdits,
        checkoutBlocks,
        postPurchaseBlocks,
        cartTargeting,
        upsellProductRules,
        testTypes,
      } = action.payload;

      draft.isSuccess = true;
      draft.draftExperience = {
        id: "draft",
        offerProducts,
        testTypes,
        offer,
        userInterfaces,
        onsiteInjections,
        onsiteEdits,
        checkoutBlocks,
        postPurchaseBlocks,
        cartTargeting,
        upsellProductRules,
        redirects: null,
      };
    },
    resetDraftExperience: (draft) => {
      draft.draftExperience = initialState.draftExperience;
    },
  },
  selectors: {
    getDraftExperience: (state) => state.draftExperience,
  },
});
export const { resetDraftExperience, setDraftExperience } =
  draftExperienceSlice.actions;

export const draftExperienceReducer = draftExperienceSlice.reducer;

export const { getDraftExperience } = draftExperienceSlice.selectors;
